import { Button, Grid, Modal, makeStyles } from '@material-ui/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchTagsByUser } from '../../../../redux/actions/flag-actions';
import { default as config } from '../../../../constants/constants';
import { firebase } from '../../../../firebase';
import { isKeyIdeaFlag, isRetrievalTag } from '../../../../utils/tagValidatorUtils';
import CommentLabel from '../../../flags/components/CommentLabel';
import TagLabel from '../../../flags/components/TagLabel';
import '../../../player/styles/capture-flags.css';
import CaptureWithTag from '../../../../components/highlight/CaptureWithTag';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const FlagRowFooterInPdfViewer = ({
  flag,
  handleRefreshPdfViewer,
  fetchTags,
  tags
}) => {
  const classes = useStyles();

  const [inputTagName, setInputTagName] = useState('');
  const [inputCommentName, setInputCommentName] = useState('');
  const [radioButtonValue, setRadioButtonValue] = useState('');
  const [show, setShow] = useState(false);
  const [tagError, setTagError] = useState(false);

  useEffect(() => {
    setInputTagName(flag?.flashflag ? '' : flag?.tag || '');
  }, [flag?.flashflag, flag?.tag]);

  useEffect(() => {
    setInputCommentName(flag?.dictation);
  }, [flag?.dictation]);

  const handleShow = () => {
    getTags();
    if (flag?.isMine) {
      const tag = flag?.tag === 'FLASH' && flag?.flashflag ? '' : flag?.tag;

      setShow(true);
      setInputCommentName(flag?.dictation);
      setInputTagName(tag);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleTagInputChange = (event) => {
    const { value } = event.target;
    setRadioButtonValue(null);
    setInputTagName(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleCommentInputChange = (event) => {
    const { value } = event.target;
    setInputCommentName(value);
  };

  const handleRadioChange = (value) => {
    setInputTagName(value);
    setRadioButtonValue(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const onUpdate = async () => {
    try {
      let request = {};
      let url;
      let resultTag = false;
      let resultComment = false;

      // Update tag
      const tag = inputTagName?.trim() || '';

      if (
        (tag !== flag?.tag || tag === 'FLASH') &&
        !(tag === '' && flag?.tag === 'FLASH' && flag?.flashflag) &&
        !(tag === 'FLASH' && flag?.tag === 'FLASH' && !flag?.flashflag)
      ) {
        request.flagId = flag.flagId;
        request.tag = tag === '' ? 'FLASH' : tag;

        // If tag is empty, set flashflag
        if (tag === '') {
          request.flashflag = true;
        }

        url = `${config.serverURL}/tags`;
        resultTag = await updateFields(request, url);
      }

      // Update comment
      if (inputCommentName !== flag?.dictation) {
        request.id = flag.flagId;
        request.dictation = inputCommentName;
        url = `${config.serverURL}/notes`;
        resultComment = await updateFields(request, url);
      }

      //if any of that(tag or comment) has changed should refresh pdf viewer
      if (resultTag || resultComment) {
        handleRefreshPdfViewer(true);
      }
    } catch (error) {
      // TODO: Error handling
      console.error(error);
    }
  };

  const updateFields = async (request, url) => {
    const token = await firebase.auth.currentUser.getIdToken();
    const options = {
      method: 'PUT',
      headers: { 'X-Firebase-Auth': token },
      url: url,
      data: request
    };
    try {
      const response = await axios(options);
      if (response.data) {
        return response.data;
      }
    } catch (error) {
      return false;
    }
  };

  const getTags = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await fetchTags(token);
    }
  };

  return (
    <>
      {flag?.isShared &&
      (!flag?.sharedCommentEnabled ||
        (flag?.sharedCommentEnabled && flag.dictation === '')) &&
      flag?.tag !== 'DOWNTAG' &&
      flag?.tag !== 'UPTAG' ? (
        <></>
      ) : flag?.isShared &&
        flag?.sharedCommentEnabled &&
        flag.dictation !== '' &&
        flag?.tag !== 'DOWNTAG' &&
        flag?.tag !== 'UPTAG' ? (
        <div style={{ marginTop: '10px' }}>
          <div className="comment-flag">{flag?.dictation}</div>
        </div>
      ) : (
        <div
          style={{
            marginTop: '10px',
            cursor: !flag?.isMine ? 'not-allowed' : 'pointer'
          }}
        >
          <TagLabel
            tag={flag?.tag}
            flashflag={flag?.flashflag}
            onTagClick={flag?.isMine ? handleShow : null}
            source="PDF"
          />
          <CommentLabel
            dictation={flag?.dictation}
            {...(flag?.isMine &&
              !isRetrievalTag(flag?.tag) && {
                onCommentClick: handleShow
              })}
            source="PDF"
          />
        </div>
      )}
      <Modal
        className={classes.modal}
        open={show}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        disableEscapeKeyDown
      >
        <div className="capture-flags-modal">
          <Grid
            item
            xs={12}
            className="capture-flags-modal__header-btn"
            style={{ textAlign: 'right' }}
          >
            <Button onClick={handleClose}>x</Button>
          </Grid>
          <CaptureWithTag
            edit={
              flag?.tag === 'UPTAG' ||
              flag?.tag === 'DOWNTAG' ||
              isRetrievalTag(flag?.tag)
            }
            tags={tags}
            inputTagName={inputTagName}
            inputCommentName={inputCommentName}
            radioButtonValue={radioButtonValue}
            handleTagInputChange={handleTagInputChange}
            handleCommentInputChange={handleCommentInputChange}
            handleRadioChange={handleRadioChange}
            onClose={handleClose}
            saveFlagWithTag={onUpdate}
            tagError={tagError}
            setTagError={setTagError}
          />
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (store) => {
  return {
    tags: store.flag.tags
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTags: (token) => {
      dispatch(fetchTagsByUser(token));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlagRowFooterInPdfViewer);
